import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';
import { defaultPageSize } from '../../helpers/constants';

const totalRecord = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_STATIONS_SUCCESS:
      return action.startIndex === 0 ? action.totalRecord : state;
    default:
      return state;
  }
}

const totalPage = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_STATIONS_SUCCESS:
      return action.totalPage
    default:
      return state;
  }
}

const currentPage = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_PAGINATION_PAGE:
      return action.currentPage;
    case actionTypes.SEARCH_STATIONS_SUCCESS:
      return action.startIndex;
    default:
      return state;
  }
}

const rowsPerPage = (state = defaultPageSize, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_PAGINATION_ROWS_PER_PAGE:
      return action.rowsPerPage;
    default:
      return state;
  }
}

export default combineReducers({
  totalRecord,
  currentPage,
  rowsPerPage,
  totalPage
});